import { lazy } from 'react';

export const LazyErrorPage = lazy(() =>
  import('./ErrorPage').then((module) => ({ default: module.ErrorPage })),
);
